module.exports = "/assets/data/97da449aa3eb6ea90e3045d147033c11-DD6.data.json";